import styled from '@emotion/styled'
import { radius, spacing } from '@mobi/component-library/Theme/Common'
import { MarketPillStyled } from '../../../BetInfoHeader/Components/Common/Header.styles'

export const RacePillStyled = styled(MarketPillStyled)({
  flexShrink: 0,
  gap: spacing.smx2,
  fontWeight: 'normal',

  '*': { flexShrink: 0 },
})

export const HeaderWrapperStyled = styled.div({
  display: 'flex',
  alignItems: 'center',
  gap: spacing.smx2,

  '> *': {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },

  '> div': {
    padding: 0,
    wordBreak: 'unset',
    wordWrap: 'unset',
    textTransform: 'uppercase',
  },

  '> span:last-of-type': {
    flexShrink: 0,
    boxSizing: 'border-box',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '2rem',
    marginLeft: 'auto',
    paddingLeft: spacing.smx1,
    paddingRight: spacing.smx1,
    lineHeight: 1,
    fontWeight: 'normal',
    borderRadius: radius.pill,
    background: 'rgba(0,0,0,0.15)',
  },
})
